import { ReactNode } from 'react';

import { Redirect, Route, RouteProps, useLocation } from 'react-router-dom';

import Layout from 'components/Layout';
import useAuth from 'hooks/useAuth';
import useCurrentUser from 'hooks/useCurrentUser';
import redirectToAuth from 'utils/redirectToAuth';

type PrivateRouteProps = RouteProps & {
  children: ReactNode;
};

export default function PrivateRoute({ children, ...rest }: PrivateRouteProps) {
  const { pathname } = useLocation();
  const currentUser = useCurrentUser();
  const auth = useAuth();

  return (
    <Route
      {...rest}
      render={() => {
        // Dispacha o usuário para o login se ele não tiver autenticado
        if (!auth.isAuthenticated) {
          redirectToAuth();
          return null;
        }
        // Dispacha o usuário para a página inicial se ele não possuir acesso ao recurso de grupos
        if (
          !currentUser?.modulos.is_access_grupo_modulo &&
          pathname === '/grupos'
        ) {
          return <Redirect to="/" />;
        }

        return <Layout {...rest}>{children}</Layout>;
      }}
    />
  );
}
